import i18n from 'rcx_i18n';

export function setUTCTime(time: number | string | Date = new Date()) {
    const _time = new Date(time);
    const year = _time.getFullYear();
    const month = _time.getMonth();
    const date = _time.getDate();
    return Date.UTC(year, month, date);
}

export function getTimestamp(time: string | string | Date = new Date()) {
    const _date = new Date(time);
    return _date.getTime();
}

export function formatUTCDate(date: Date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const formatDuration = (duration: number): string => {
    const hour = Math.floor(duration / 3600);
    const minute = Math.floor((duration - hour * 3600) / 60);
    const second = duration - hour * 3600 - minute * 60;

    const hourText = !hour ? '' : `${hour} ${i18n.t('common.hour')} `;
    const minuteText = !minute ? '' : `${minute} ${i18n.t('common.minute')} `;
    const secondText = `${second} ${i18n.t('common.second')}`;

    return `${hourText}${minuteText}${secondText}`;
};
